import { ENDPOINT_LLM } from "@/constants";

export const ENDPOINT_OCR = ENDPOINT_LLM;
export const DOCS_URL_OCR = 'https://docs.opentyphoon.ai/en/ocr/';
export const MODEL_TYPHOON_OCR = 'typhoon-ocr-7b';